import React, { useEffect } from "react";

import CoachFeedCard from "../component/CoachFeedCard";
import CoachFeedModal from "../component/CoachFeedModal";
import { useState } from "react";
import { Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert';
import { GetPost } from '../api'
import { useSelector, shallowEqual } from 'react-redux'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CoachFeed = () => {
  
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setForm({
      description: null,
      image: null,
      title: null
    })
    setShow(true)
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [pending, setPending] = useState(false);
  const [posts, setPosts] = useState([]);

  const [form, setForm] = useState({
    title: null,
    description: null,
    image: null
  })

  const [snackbar, setSnackbar] = useState(() => ({
    isOpen: false,
    message: '',
    type: 'success'
  }))

  useEffect(()=>{
    handleGetPost();
  }, [])

  const handleGetPost = async () => {
    try{
      setPending(true);
      let res = await GetPost(user.id);
      setPosts(res.posts)
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackbar({
        isOpen: true,
        message: error,
        type: 'error'
      })
    }finally{
      setPending(false);
    }
  }

  return (
    <>
      <Snackbar style={{zIndex: 99999}} open={snackbar.isOpen} autoHideDuration={6000} onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }}>
            <Alert onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }} severity={snackbar.type}>
                {snackbar.message}
            </Alert>
        </Snackbar>   
      <div className="container mx-auto  m-0 p-0">
        <div className="row pb-5 m-0">
          <h1 className="font-bold py-5">CoachFeed</h1>
        </div>

        <div className=" bg-white shadow-lg py-5">
          <div className=" d-flex justify-content-end pr-5">
            <button className="bg-primary text-white px-5 font1 py-3 rounded border-0 " onClick={handleShow}>
              Create New Feed
            </button>
          </div>

          <div className="row m-0 py-5">
            {pending && <div className="w-100 d-flex align-items-center justify-content-between mb-2">
              <div
                class="spinner-border text-danger mx-auto"
                role="status"
              ></div>
            </div>}
            {!pending && posts.length == 0 && <h1 className="text-center w-100">No Post Found</h1>}
            {!pending && posts.length > 0 && posts.map((data, i)=>{
              return <CoachFeedCard handleGetPost={handleGetPost} setSnackbar={setSnackbar} key={i} post={data} />
            })}
          </div>
        </div>
      </div>
      <CoachFeedModal handleGetPost={handleGetPost} setSnackbar={setSnackbar} show={show} handleClose={handleClose} />
    </>
  );
};

export default CoachFeed;
